import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

const karagatanURL = process.env.GEOSERVER;

////////FAO 266 Implementation

const vmm = new LayerGroup({
  title: "Vessel Monitoring Measures (FAO 266) Implementation",
  fold: "close",
  layers: [
    new LayerTile({
      title: "LGUs Calling for the Full Implementation of FAO 266",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:lgu_vmm",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Protected Areas Requesting Access to VMM",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:protected_areas_vmm",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
  ],
});

export default vmm;
